var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-wrapper"},[_c('intro-header'),_c('div',[_c('div',{staticClass:"intromain",style:(_vm.containerStyles)},[_c(_vm.currentComponent,{tag:"component"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }